import { Component, OnInit,ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService} from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { WxjssdkService }from "src/service/wxjssdk.service";
declare var app;
@Component({
  selector: 'app-a2-reminder-detail',
  templateUrl: './a2-reminder-detail.component.html',
  styleUrls: ['./a2-reminder-detail.component.scss']
})
export class A2ReminderDetailComponent extends GridBaseCase {
  tabsIndex = 0;
  information:any={};
  month: any = new Date();
  content:any=null;
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:any = "";
  tel:any;//手机号码
  typeall:any;//所有用户标签
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private native:NativeService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    public wx:WxjssdkService
  ) { super(); 
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.baseService.FixedSubmitBtn.configName = "reminderDetail";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "添加沟通记录";
    this.baseService.FixedSubmitBtn.type = 1000;
    this.baseService.FixedSubmitBtn["isbtn"]=false;
    if(sessionStorage.getItem(this.pageName+"_page")){
            this.tabsIndex=parseInt(sessionStorage.getItem(this.pageName+"_page"));
            sessionStorage.removeItem(this.pageName+"_page");
        if(this.tabsIndex==2){
          this.baseService.FixedSubmitBtn["isbtn"]=true;
        }
       }
    
  }


  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  tabsEvent(index){
    const that=this;
    that.tabsIndex = index;
     sessionStorage.setItem(that.pageName+"_page",that.tabsIndex.toString());
     if(index==2){
      const id = that.activaRouter.snapshot.paramMap.get('id');
      if(id){
        that.baseService.FixedSubmitBtn["isbtn"]=true;
        that.baseService.FixedSubmitBtn["url"]=that.config[index].url+id.split('&')[0];
      }else{
        that.baseService.FixedSubmitBtn["isbtn"]=false;
      }
     }else{
      that.baseService.FixedSubmitBtn["isbtn"]=false;
     }
     that.LoadData(1);
  }
  /**
   * 打电话
   * @param event 电话号码
   */
  EventCall(event){
  this.native.GetCallPhone(event).then(fail=>{
    console.log(fail);
  }).catch(error=>{
    console.log(error);
  })
  }
  /**
   * 发短信
   * @param event 电话号码
   */
  EventMessage(event){
    let text = "";
    if(this.content){
      text=this.content.value
    }
    this.native.GetSendMsg(event,text).then(sucess=>{
     console.log(sucess);
    }).catch(error=>{
      console.log(error);
    });
  }

  LoadData(PageNumber){
    let that = this;
    that.information = that.com.GetStorageKey("information")||{};
    console.log("时间=============================");
    console.log( that.information);
    if(that.information["birthday"] && that.information["birthday"].value){
      that.information["birthday"].value = that.information["birthday"].value.toString().replace(/-/g,"/");
    }
    if(that.information["phone"] && that.information["phone"].value){
      that.tel = that.com.PhoneNum(that.information["phone"].value);
    }
    if(that.information["typeall"] && that.information["typeall"].value){
    that.typeall= that.information["typeall"].value;
    }
    that.element = that.config[that.tabsIndex];
    console.log(that.config);
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if(that.tabsIndex==0){
      let typeObj = {};
      if(PageName == 'RepurchaseDetail'){
        typeObj = {"ReminderType":1};
      }else if(PageName == 'TransitionDetail'){
        typeObj = {"ReminderType":2};
      }else if(PageName == 'AwakenDetail'){
        typeObj = {"ReminderType":3};
      }else if(PageName == 'BirthdayDetail'){
        typeObj = {"ReminderType":4};
      }else if(PageName == 'NewcustomersDetail'){
        typeObj = {"ReminderType":5};
      }
      body.RequestBody = JSON.stringify(typeObj);
    }else if(that.tabsIndex==1)
    {
      body.RequestBody = JSON.stringify({"FK_MembersInfoManagement_ID":that.information.id.value});
    }else if(that.tabsIndex==2){
      body.RequestBody = JSON.stringify({"FK_MembersInfoManagement_ID":that.information.id.value});
    }
   
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if((element.bindingField == 'date') && objfield[element.bindingField].value){
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
            }
          });
          that.dataArrayList.push(objfield);
        });
        if(that.tabsIndex==0){//话语
          if(that.dataArrayList[0]){
            that.content = that.dataArrayList[0].content;
          }
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }



 /**
  * 打开微信
  */
 Eventweixin(){
  console.log("复制内容复制内容复制内容+++++++++++++++++");
  const that=this;
  let text = "";
  if(that.content){
    text=that.content.value;
  }
  var aux = document.createElement("input"); 
  console.log(aux);
    aux.setAttribute("value", text); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    console.log(aux);
   console.log("打开微信"); 
   if(that.com.IsWeixinBrowser){//如果是微信
    if(that.information.wechat_id){//如果微信ID存在
      if(that.information.wechat_id.value){
        that.wx.CreateopenEnterpriseChat("",that.information.wechat_id.value,"").then(res=>{
          // that.msg.Alert(JSON.stringify(res));
        }).catch(res=>{
          that.msg.Alert(res.ResponseMessage.ErrorMessage).then(data=>{
            if(res.ResponseMessage.ErrorCode==404){}
              that.wx.OpenUserProfile(2,that.information.wechat_id.value).then(res=>{
                // that.msg.Alert(res.ResponseMessage.ErrorMessage);
              }).catch(res=>{
                // if(app.DEBUG){
                //   that.msg.Alert(res.ResponseMessage.ErrorMessage);
                // }
              that.msg.Alert(res.ResponseMessage.ErrorMessage);
              });
          });
        });
        return;
      }
    }
    //如果没有微信userID
     that.wx.selectExternalContact(0).then(res=>{
       if(res.ResponseMessage.Success){
         let userinfo:string =res.Status[0].toString();
         that.information["wechat_id"]={"value":userinfo,"text":"企业微信USERID"};
         console.log(userinfo,"用户userID");
         try{
          that.EventListBind(userinfo,that.information.id.value);
         }catch(err){
           console.log(err,"错误信息列表");
         }
         that.wx.CreateopenEnterpriseChat("",userinfo,"").then(res=>{
          //  that.msg.Alert(JSON.stringify(res));
         }).catch(res=>{
          if(app.DEBUG){
               that.msg.Alert(res.ResponseMessage.ErrorMessage);
             }
         });
       };
     }).catch(err=>{
       if(app.DEBUG){
        that.msg.Alert(err.ResponseMessage.ErrorMessage);
       }
     
     });
    //  that.wx.CreateopenEnterpriseChat("","","").then(wb=>{
    //   console.log(wb);
    // }).catch(er=>{
    //  console.log(er,"cuowu");
    // });
    }
 
 }
 /**
  * 添加沟通记录
  * @param tabindex 选项卡下标
  * @param item 当前行数据
  */
 EventClick(tabindex){
  const id = this.activaRouter.snapshot.paramMap.get('id');
  if(id){
    this.com.setHistoryUrl(false);
    // this.router.navigate([this.config[tabindex].url+id.split('&')[0]+"&"+this.com.getNowDatetime]);
    this.com.Go(this.config[tabindex].url+id.split('&')[0]+"&"+this.com.getNowDatetime);
    
  }
 }
 EventSubmitClick(){
   console.log(this.config);
   this.EventClick(2);
}
/**
 * 当前人如果没有微信，则需要去选择微信联系人，并且获取对应的userID
 * @param userID 获取当前选中的微信对应的userID
 * @param id 当前会员的ID
 */
EventListBind(userID:string,id:any){
  const that=this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "MembersInfoManagementXML";
  body.OpType = "EDITE";
  body.ConfigType = "form";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.RequestBody=JSON.stringify({"a_WeChat_ID":userID,"a_ID": id});
  that.http.post(app.DEFAULTURL, body).then(data => {
    /****判断是否第一页end****/
    if (data.ResponseMessage.Success) {
      console.log(data,"添加会员的userID到数据库中成功");
    } else {
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }
  }).catch(error => {
    console.log(error);
    that.msg.Alert(error.ResponseMessage.ErrorMessage);
  });
}
 
}
